import { render, staticRenderFns } from "./LoaderBackdrop.vue?vue&type=template&id=650cc205&scoped=true&"
import script from "./LoaderBackdrop.vue?vue&type=script&lang=js&"
export * from "./LoaderBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./LoaderBackdrop.vue?vue&type=style&index=0&id=650cc205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650cc205",
  null
  
)

export default component.exports